(function (Drupal) {
  /**
   * Setup and attach the toggle behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.toggle = {
    attach: function () {
      let toggleShow = document.getElementById('utility-nav--mobile-toggle');
      let toggleClose = document.getElementById('utility-nav--mobile-close');
      let toggleMenu = document.getElementById('utility-nav--mobile-items');

      if(toggleShow) {
        toggleShow.onclick = function () {
          toggleMenu.classList.toggle('show');
        };
      }

      if(toggleClose) {
        toggleClose.onclick = function () {
          toggleMenu.classList.toggle('show');
        };
      }
    }
  };
})(Drupal);
